"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.BeaconEventHandler = exports.defaultEventCallbacks = exports.BeaconEvent = void 0;
const Toast_1 = require("./alert/Toast");
const Alert_1 = require("./alert/Alert");
const qr_1 = require("./utils/qr");
const Logger_1 = require("./utils/Logger");
const BeaconError_1 = require("./errors/BeaconError");
const block_explorer_1 = require("./utils/block-explorer");
const _1 = require(".");
const logger = new Logger_1.Logger('BeaconEvents');
var BeaconEvent;
(function (BeaconEvent) {
    BeaconEvent["PERMISSION_REQUEST_SENT"] = "PERMISSION_REQUEST_SENT";
    BeaconEvent["PERMISSION_REQUEST_SUCCESS"] = "PERMISSION_REQUEST_SUCCESS";
    BeaconEvent["PERMISSION_REQUEST_ERROR"] = "PERMISSION_REQUEST_ERROR";
    BeaconEvent["OPERATION_REQUEST_SENT"] = "OPERATION_REQUEST_SENT";
    BeaconEvent["OPERATION_REQUEST_SUCCESS"] = "OPERATION_REQUEST_SUCCESS";
    BeaconEvent["OPERATION_REQUEST_ERROR"] = "OPERATION_REQUEST_ERROR";
    BeaconEvent["SIGN_REQUEST_SENT"] = "SIGN_REQUEST_SENT";
    BeaconEvent["SIGN_REQUEST_SUCCESS"] = "SIGN_REQUEST_SUCCESS";
    BeaconEvent["SIGN_REQUEST_ERROR"] = "SIGN_REQUEST_ERROR";
    BeaconEvent["BROADCAST_REQUEST_SENT"] = "BROADCAST_REQUEST_SENT";
    BeaconEvent["BROADCAST_REQUEST_SUCCESS"] = "BROADCAST_REQUEST_SUCCESS";
    BeaconEvent["BROADCAST_REQUEST_ERROR"] = "BROADCAST_REQUEST_ERROR";
    BeaconEvent["LOCAL_RATE_LIMIT_REACHED"] = "LOCAL_RATE_LIMIT_REACHED";
    BeaconEvent["NO_PERMISSIONS"] = "NO_PERMISSIONS";
    BeaconEvent["ACTIVE_ACCOUNT_SET"] = "ACTIVE_ACCOUNT_SET";
    BeaconEvent["ACTIVE_TRANSPORT_SET"] = "ACTIVE_TRANSPORT_SET";
    BeaconEvent["P2P_CHANNEL_CONNECT_SUCCESS"] = "P2P_CHANNEL_CONNECT_SUCCESS";
    BeaconEvent["P2P_LISTEN_FOR_CHANNEL_OPEN"] = "P2P_LISTEN_FOR_CHANNEL_OPEN";
    BeaconEvent["INTERNAL_ERROR"] = "INTERNAL_ERROR";
    BeaconEvent["UNKNOWN"] = "UNKNOWN";
})(BeaconEvent = exports.BeaconEvent || (exports.BeaconEvent = {}));
const showSentToast = async () => {
    Toast_1.openToast({ body: 'Request sent', timer: 3000 }).catch((toastError) => console.error(toastError));
};
const showNoPermissionAlert = async () => {
    await Alert_1.openAlert({
        title: 'No Permission',
        body: 'Please allow the wallet to handle this type of request.'
    });
};
const showErrorAlert = async (beaconError) => {
    const error = beaconError.errorType
        ? BeaconError_1.BeaconError.getError(beaconError.errorType)
        : new _1.UnknownBeaconError();
    await Alert_1.openAlert({
        title: error.title,
        body: error.description
    });
};
const showRateLimitReached = async () => {
    Toast_1.openToast({
        body: 'Rate limit reached. Please slow down',
        timer: 3000
    }).catch((toastError) => console.error(toastError));
};
const showOkAlert = async () => {
    await Alert_1.openAlert({
        title: 'Success',
        confirmButtonText: 'Done',
        timer: 1500
    });
};
const showInternalErrorAlert = async (data) => {
    const alertConfig = {
        title: 'Internal Error',
        confirmButtonText: 'Done',
        body: `${data}`,
        confirmCallback: () => undefined
    };
    await Alert_1.openAlert(alertConfig);
};
const showQrCode = async (data) => {
    const dataString = JSON.stringify(data);
    console.log(dataString);
    const alertConfig = {
        title: 'Pair with Wallet',
        confirmButtonText: 'Done',
        body: `${qr_1.getQrData(dataString, 'svg')}<br /><br />Don't know what to do with this QR code? <a href="https://docs.walletbeacon.io/supported-wallets.html" target="_blank">Click here</a> to learn more.`,
        confirmCallback: () => undefined
    };
    await Alert_1.openAlert(alertConfig);
};
const showPermissionSuccessAlert = async (data) => {
    const { account, output } = data;
    const alertConfig = {
        title: 'Permission Granted',
        body: `We received permissions for the address <strong>${output.address}</strong>
    <br>
    <br>
    Network: <strong>${output.network.type}</strong>
    <br>
    Permissions: <strong>${output.scopes}</strong>`,
        confirmButtonText: 'Done',
        confirmCallback: () => undefined,
        actionButtonText: 'Open Blockexplorer',
        actionCallback: async () => {
            const link = await block_explorer_1.getAccountBlockExplorerLinkForNetwork(account.network, output.address);
            window.open(link, '_blank');
        }
    };
    await Alert_1.openAlert(alertConfig);
};
const showOperationSuccessAlert = async (data) => {
    const { account, output } = data;
    const alertConfig = {
        title: 'Operation Broadcasted',
        body: `The transaction has successfully been broadcasted to the network with the following hash. <strong>${output.transactionHash}</strong>`,
        confirmButtonText: 'Done',
        confirmCallback: () => undefined,
        actionButtonText: 'Open Blockexplorer',
        actionCallback: async () => {
            const link = await block_explorer_1.getTransactionBlockExplorerLinkForNetwork(account.network, output.transactionHash);
            window.open(link, '_blank');
        }
    };
    await Alert_1.openAlert(alertConfig);
};
const showSignSuccessAlert = async (data) => {
    const output = data.output;
    const alertConfig = {
        title: 'Transaction Signed',
        body: `The transaction has successfully been signed.
    <br>
    Signature: <strong>${output.signature}</strong>`,
        confirmButtonText: 'Done',
        confirmCallback: () => undefined
    };
    await Alert_1.openAlert(alertConfig);
};
const showBroadcastSuccessAlert = async (data) => {
    const { network, output } = data;
    const alertConfig = {
        title: 'Broadcasted',
        body: `The transaction has successfully been broadcasted to the network with the following hash. <strong>${output.transactionHash}</strong>`,
        confirmButtonText: 'Done',
        confirmCallback: () => undefined,
        actionButtonText: 'Open Blockexplorer',
        actionCallback: async () => {
            const link = await block_explorer_1.getTransactionBlockExplorerLinkForNetwork(network, output.transactionHash);
            window.open(link, '_blank');
        }
    };
    await Alert_1.openAlert(alertConfig);
};
const emptyHandler = (eventType) => async (data) => {
    logger.log('emptyHandler', eventType, data);
};
exports.defaultEventCallbacks = {
    [BeaconEvent.PERMISSION_REQUEST_SENT]: showSentToast,
    [BeaconEvent.PERMISSION_REQUEST_SUCCESS]: showPermissionSuccessAlert,
    [BeaconEvent.PERMISSION_REQUEST_ERROR]: showErrorAlert,
    [BeaconEvent.OPERATION_REQUEST_SENT]: showSentToast,
    [BeaconEvent.OPERATION_REQUEST_SUCCESS]: showOperationSuccessAlert,
    [BeaconEvent.OPERATION_REQUEST_ERROR]: showErrorAlert,
    [BeaconEvent.SIGN_REQUEST_SENT]: showSentToast,
    [BeaconEvent.SIGN_REQUEST_SUCCESS]: showSignSuccessAlert,
    [BeaconEvent.SIGN_REQUEST_ERROR]: showErrorAlert,
    [BeaconEvent.BROADCAST_REQUEST_SENT]: showSentToast,
    [BeaconEvent.BROADCAST_REQUEST_SUCCESS]: showBroadcastSuccessAlert,
    [BeaconEvent.BROADCAST_REQUEST_ERROR]: showErrorAlert,
    [BeaconEvent.LOCAL_RATE_LIMIT_REACHED]: showRateLimitReached,
    [BeaconEvent.NO_PERMISSIONS]: showNoPermissionAlert,
    [BeaconEvent.ACTIVE_ACCOUNT_SET]: emptyHandler(BeaconEvent.ACTIVE_ACCOUNT_SET),
    [BeaconEvent.ACTIVE_TRANSPORT_SET]: emptyHandler(BeaconEvent.ACTIVE_TRANSPORT_SET),
    [BeaconEvent.P2P_CHANNEL_CONNECT_SUCCESS]: showOkAlert,
    [BeaconEvent.P2P_LISTEN_FOR_CHANNEL_OPEN]: showQrCode,
    [BeaconEvent.INTERNAL_ERROR]: showInternalErrorAlert,
    [BeaconEvent.UNKNOWN]: emptyHandler(BeaconEvent.UNKNOWN)
};
class BeaconEventHandler {
    constructor(eventsToOverride = {}) {
        this.callbackMap = {
            [BeaconEvent.PERMISSION_REQUEST_SENT]: [exports.defaultEventCallbacks.PERMISSION_REQUEST_SENT],
            [BeaconEvent.PERMISSION_REQUEST_SUCCESS]: [exports.defaultEventCallbacks.PERMISSION_REQUEST_SUCCESS],
            [BeaconEvent.PERMISSION_REQUEST_ERROR]: [exports.defaultEventCallbacks.PERMISSION_REQUEST_ERROR],
            [BeaconEvent.OPERATION_REQUEST_SENT]: [exports.defaultEventCallbacks.OPERATION_REQUEST_SENT],
            [BeaconEvent.OPERATION_REQUEST_SUCCESS]: [exports.defaultEventCallbacks.OPERATION_REQUEST_SUCCESS],
            [BeaconEvent.OPERATION_REQUEST_ERROR]: [exports.defaultEventCallbacks.OPERATION_REQUEST_ERROR],
            [BeaconEvent.SIGN_REQUEST_SENT]: [exports.defaultEventCallbacks.SIGN_REQUEST_SENT],
            [BeaconEvent.SIGN_REQUEST_SUCCESS]: [exports.defaultEventCallbacks.SIGN_REQUEST_SUCCESS],
            [BeaconEvent.SIGN_REQUEST_ERROR]: [exports.defaultEventCallbacks.SIGN_REQUEST_ERROR],
            [BeaconEvent.BROADCAST_REQUEST_SENT]: [exports.defaultEventCallbacks.BROADCAST_REQUEST_SENT],
            [BeaconEvent.BROADCAST_REQUEST_SUCCESS]: [exports.defaultEventCallbacks.BROADCAST_REQUEST_SUCCESS],
            [BeaconEvent.BROADCAST_REQUEST_ERROR]: [exports.defaultEventCallbacks.BROADCAST_REQUEST_ERROR],
            [BeaconEvent.LOCAL_RATE_LIMIT_REACHED]: [exports.defaultEventCallbacks.LOCAL_RATE_LIMIT_REACHED],
            [BeaconEvent.NO_PERMISSIONS]: [exports.defaultEventCallbacks.NO_PERMISSIONS],
            [BeaconEvent.ACTIVE_ACCOUNT_SET]: [exports.defaultEventCallbacks.ACTIVE_ACCOUNT_SET],
            [BeaconEvent.ACTIVE_TRANSPORT_SET]: [exports.defaultEventCallbacks.ACTIVE_TRANSPORT_SET],
            [BeaconEvent.P2P_CHANNEL_CONNECT_SUCCESS]: [exports.defaultEventCallbacks.P2P_CHANNEL_CONNECT_SUCCESS],
            [BeaconEvent.P2P_LISTEN_FOR_CHANNEL_OPEN]: [exports.defaultEventCallbacks.P2P_LISTEN_FOR_CHANNEL_OPEN],
            [BeaconEvent.INTERNAL_ERROR]: [exports.defaultEventCallbacks.INTERNAL_ERROR],
            [BeaconEvent.UNKNOWN]: [exports.defaultEventCallbacks.UNKNOWN]
        };
        this.overrideDefaults(eventsToOverride).catch((overrideError) => {
            logger.error('constructor', overrideError);
        });
    }
    async on(event, eventCallback) {
        const listeners = this.callbackMap[event] || [];
        listeners.push(eventCallback);
        this.callbackMap[event] = listeners;
    }
    async emit(event, data) {
        const listeners = this.callbackMap[event];
        if (listeners && listeners.length > 0) {
            listeners.forEach(async (listener) => {
                try {
                    await listener(data);
                }
                catch (listenerError) {
                    logger.error(`error handling event ${event}`, listenerError);
                }
            });
        }
    }
    async overrideDefaults(eventsToOverride) {
        Object.keys(eventsToOverride).forEach((untypedEvent) => {
            const eventType = untypedEvent;
            const event = eventsToOverride[eventType];
            if (event) {
                this.callbackMap[eventType] = [event.handler];
            }
        });
    }
}
exports.BeaconEventHandler = BeaconEventHandler;
//# sourceMappingURL=events.js.map